/* eslint-disable react/no-unused-prop-types */

/* eslint-disable react/destructuring-assignment */
import { Box, Flex } from "@chakra-ui/react";
import React, { ReactElement, isValidElement } from "react";

import { Logo } from "design_system/components/Logo";
import { colors } from "src/colors";
import getNameProp from "src/utils/getNameProp";

type Props = {
  children?: any;
  isClickable?: boolean;
  customLogoClick?: () => void;
  redirectToWebFlowWhenNotAuth?: boolean;
};

const Template = (props: Props): JSX.Element => {
  const children = React.Children.toArray(props.children).filter<ReactElement>(isValidElement);

  return (
    <Flex
      justifyContent="center"
      position="sticky"
      top={0}
      zIndex={11}
      bgColor={colors.white.off}
      p={[4, null, 6]}
      boxShadow="0px 4px 10px rgba(0, 0, 0, 0.15)"
      alignItems="center"
      {...getNameProp("template-header")}
    >
      <Box width="40px" as="button" ml={[0, 8]} {...getNameProp("template-header-children-left")}>
        {children.find((child) => child.type === Left)?.props.children}
      </Box>
      <Flex flex="1" justifyContent="center" {...getNameProp("template-header-logo")}>
        <Logo
          isClickable={props?.isClickable}
          customClick={props.customLogoClick}
          rediectToWebFlow={props.redirectToWebFlowWhenNotAuth}
        />
      </Flex>
      <Flex
        width="40px"
        justifyContent="flex-end"
        mr={[0, 8]}
        {...getNameProp("template-header-children-right")}
      >
        {children.find((child) => child.type === Right)?.props.children}
      </Flex>
    </Flex>
  );
};

const Left = ({ children }: Props) => {
  return <>{children}</>;
};
const Right = ({ children }: Props) => {
  return <>{children}</>;
};

export const Header = Object.assign(Template, { Left, Right });
